import { useFormState, UseFormStateProps, FieldValues, UseFormStateReturn } from 'react-hook-form'

interface Props extends UseFormStateProps<FieldValues> {
  render: (formState: Pick<UseFormStateReturn<FieldValues>, 'isDirty' | 'isSubmitting'>) => JSX.Element
}

const SubmitButtonFromState = ({ control, render }: Props): JSX.Element => {
  const { isDirty, isSubmitting, dirtyFields } = useFormState({ control })
  return render({ isDirty: isDirty || Object.keys(dirtyFields).length > 0, isSubmitting })
}
export default SubmitButtonFromState
